// extracted by mini-css-extract-plugin
export default {"container":"CBoh8gcIAvrEQ1pGNmiA"};